import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_redirect_simple_moves~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_redirect_simple_moves/tai-chi-walking-f-v2'
					),
			},
			upsell: {
				experiment: {
					'upsell-tai-chi-walking-f': () =>
						import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_redirect_simple_moves'),
				},
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_redirect_simple_moves~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_redirect_simple_moves/tai-chi-walking-f-v2-al'
					),
			},
			upsell: {
				experiment: {
					'upsell-tai-chi-walking-f': () =>
						import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_redirect_simple_moves'),
				},
			},
		},
		'activity-male-chair-tai-chi': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi&exp=web_redirect_simple_moves~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_redirect_simple_moves/chair-tai-chi-m'
					),
			},
			upsell: {
				experiment: {
					'upsell-activity-m': () =>
						import(
							/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_redirect_simple_moves__activity_m'
						),
				},
			},
		},
		'activity-male-chair-tai-chi-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi-al&exp=web_redirect_simple_moves~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_redirect_simple_moves/chair-tai-chi-m-al'
					),
			},
			upsell: {
				experiment: {
					'upsell-activity-m': () =>
						import(
							/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_redirect_simple_moves__activity_m'
						),
				},
			},
		},
		'activity-male-tai-chi-yoga-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-pr&exp=web_redirect_simple_moves~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_redirect_simple_moves/tai-chi-yoga-m-pr'
					),
			},
			upsell: {
				experiment: {
					'upsell-activity-m': () =>
						import(
							/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_redirect_simple_moves__activity_m'
						),
				},
			},
		},
	},
]

export default config
